import { render, staticRenderFns } from "./groupitem.vue?vue&type=template&id=e566ed50&scoped=true&"
import script from "./groupitem.vue?vue&type=script&lang=js&"
export * from "./groupitem.vue?vue&type=script&lang=js&"
import style0 from "./groupitem.vue?vue&type=style&index=0&id=e566ed50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e566ed50",
  null
  
)

export default component.exports